import React from 'react'
import { Text, Center } from '@chakra-ui/react'
import type { CenterProps } from '@chakra-ui/react'

import SharedHeader from './texts/shared-header'
import SharedInfoText from './texts/shared-info-text'

interface Props extends CenterProps {
    header?: string
    infoText?: string
}

export default function ErrorView(props: Props) {
    return (
        <Center flexDir="column" w="full" h="full" gridGap={6} {...props}>
            <SharedHeader>
                {props.header || 'Something went wrong'}{' '}
            </SharedHeader>
            <SharedInfoText>
                {props.infoText ||
                    'If the problem persists, please contact support.'}
            </SharedInfoText>
        </Center>
    )
}
